var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashboard-container"},[_c('ServicePlaceEditForm',{attrs:{"id":_vm.ServicePlaceId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }